import React from "react";
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import '../components/css/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Privacy Policy', url: '/privacy-policy' }
  ]);

  return (
    <div className="privacy-page">
      <MetaTags
        title="Privacy Policy | BookMyAudition"
        description="BookMyAudition privacy statement outlining how personal information, profile media, and audition application data are protected."
        keywords="BookMyAudition privacy policy, data protection, actor profile privacy"
        canonical="https://web.bookmyaudition.com/privacy-policy"
        schema={breadcrumbSchema}
      />
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>

        <ol className="privacy-list">
          <li>
            BookMyAudition is sensitive to privacy issues on the Internet. We believe it is important you know how we treat the information about you we receive via the Internet.
          </li>
          <li>
            In general, you can visit BookMyAudition on the World Wide Web without telling us who you are or revealing any information about yourself. Our web servers collect domain names to measure site usage and improve content.
          </li>
          <li>
            When personal information is needed (such as name, email, and mobile number), we will let you know at the time of collection how it will be used to process audition inquiries and grant account access.
          </li>
          <li>
            BookMyAudition makes every effort to maintain the security of its network and data. Any stored data is treated as confidential and protected by strict internal security policies.
          </li>
          <li>
            BookMyAudition is sensitive to the issue of children's privacy and protects young performers. If you wish to manage or remove a child's profile, contact support@bookmyaudition.com.
          </li>
          <li>
            For more information or concerns regarding BookMyAudition's Privacy Statement, please email support@bookmyaudition.com.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default PrivacyPolicy;